import aes from './encrypt'
export default {
  // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
  getCosWeb_URL: 'Wxmall/Costest/getCosWeb',
  getOssToken_URL: () => {
    return require('@/assets/common/js/config').cosuploadpath + 'Toss/getOssToken'
  },
  // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
  actNotice_URL: 'Wxmall/Sysinfo/actNotice', // creater: gaoenhui
  getNdoResult_URL: 'Wxmall/Ndo/getNdoResult', // creater: gaoenhui --皮肤测试
  jhShopPop_URL: 'Wxmall/Index/jhShopPop', // creater: gaoenhui --首页弹窗，活动期间仅普通钜惠店主及50VIP钜惠店主弹，弹窗点击进入配置分级产品链接页面(一天弹一次)
  hasNewMsg_URL: 'Wxmall/User/hasNewMsg', // creater: gaoenhui --未读消息
  readUserMsg_URL: 'Wxmall/Index/readUserMsg', // creater: gaoenhui --消息已读设置
  deleteMessageById_URL: 'Wxmall/Index/deleteMessageById', // creater: gaoenhui --消息删除
  getPresalePopu_URL: 'Wxmall/Activity/getPresalePopu',
  showMsgPop_URL: 'Wxmall/user/showMsgPop', // creater: gaoenhui --短信通知授权
  doMsgPop_URL: 'Wxmall/user/doMsgPop', // creater: gaoenhui --短信通知授权是否同意
  getMeInfo_URL: 'Wxmall/User/getMeInfo', // creater: gaoenhui
  getPopupInfo_URL: 'Wxmall/Qwqrcode/getPopupInfo', // creater: gaoenhui --企微二维码弹窗
  getIndexPopu_URL: 'Wxmall/DrainageDraw/getIndexPopu', // creater: gaoenhui --引流活动相关弹窗
  getGoldByActivity_URL: 'Wxmall/Goldmall/getGoldByActivity', // creater: gaoenhui --2021-4-26新增金币雨活动
  getUserBirthdayPop_URL: 'Wxmall/Index/getUserBirthdayPop', // creater: gaoenhui --2023-4-26 完善生日信息弹窗
  checkActivityShow_URL: 'Wxmall/Adactinfo/checkActivityShow', // creater: gaoenhui --判断是否为新用户 新人有礼弹窗
  getYearLivePopupInfo_URL: 'Wxmall/index/getYearLivePopupInfo', // creater: gaoenhui --2022-7周年回忆杀弹窗
  getOrderCoupon_URL: 'Wxmall/Adactinfo/getOrderCoupon', // creater: gaoenhui --订单发券弹窗:有新发的券则显示
  checkActivityShow_act_URL: 'Wxmall/ElevenActivity/checkActivityShow', // creater: gaoenhui --红包雨活动
  getVipPopads_URL: 'Wxmall/Adactinfo/getVipPopads', // creater: gaoenhui --2021-4-22新增50vip礼包弹框
  getTopMessage_URL: 'Wxmall/Index/getTopMessage', // creater: gaoenhui
  getIndex_URL: 'Wxmall/Home/getIndex', // creater: gaoenhui --首页基础信息
  getRecommend_URL: 'Wxmall/Home/getRecommend', // creater: gaoenhui --首页推荐商品
  addCoupon_URL: 'Wxmall/ElevenActivity/addCoupon', // creater: gaoenhui --红包雨活动红包领取
  claimWelfare_URL: 'Wxmall/Activity/claimWelfare', // 新人折扣福利领取
  getMarketNaviList_URL: 'Wxmall/Market/getMarketNaviList', // creater: gaoenhui --分类基础信息
  getSeriesNaviList_URL: 'Wxmall/Market/getSeriesNaviList', // creater: gaoenhui --系列基础信息
  getMallCommunityIndexPop_URL: 'Wxmall/Home/getMallCommunityIndexPop', // creater: gaoenhui --社区首页弹窗
  getIndexPopu_community_URL: 'Wxmall/Community/getIndexPopu', // creater: gaoenhui --官方消息弹框
  getOssWeb_URL: 'Wxmall/Sysinfo/getOssWeb', // creater: gaoenhui --web端图片上传oss权限获取
  updateMainInfo_URL: 'Wxmall/Community/updateMainInfo', // creater: gaoenhui --社区主页修改用户背景图&个人介绍
  modifyUser_URL: 'Wxmall/Community/modifyUser', // creater: gaoenhui --社区主页修改用户头像&昵称
  getMain_URL: 'Wxmall/Community/getMain', // creater: gaoenhui --个人主页
  getCollectionList_Community_URL: 'Wxmall/Community/getCollectionList', // creater: gaoenhui --文章收藏/文章点赞列表
  getMainPostsList_URL: 'Wxmall/Community/getMainPostsList', // creater: gaoenhui --个人主页作品
  deletePosts_URL: 'Wxmall/CommunityPosts/deletePosts', // creater: gaoenhui --删除文章/草稿
  setMePostsTop_URL: 'Wxmall/Community/setMePostsTop', // creater: gaoenhui --作者设置帖子置顶
  follow_community_URL: 'Wxmall/Community/follow', // creater: gaoenhui --关注/取关
  getHotIndex_URL: 'Wxmall/CommunityPosts/getHotIndex', // creater: gaoenhui --热门话题&分类标签
  getPostsByType_URL: 'Wxmall/CommunityPosts/getPostsByType', // creater: gaoenhui --根据分类标签获取帖子
  getFollowPosts_URL: 'Wxmall/Community/getFollowPosts', // creater: gaoenhui --关注用户帖子列表
  getTopicPosts_URL: 'Wxmall/CommunityPosts/getTopicPosts', // creater: gaoenhui --话题对应帖子列表
  getNoteAnalysis_URL: () => {
    // creater: gaoenhui --数据中心-笔记分析
    return require('@/assets/common/js/config').datacenterpath + 'Wxmall/Community/getNoteAnalysis'
  },
  getBaseData_URL: () => {
    // creater: gaoenhui --账号概览-账号基础数据
    return require('@/assets/common/js/config').datacenterpath + 'Wxmall/Community/getBaseData'
  },
  getPostsOperation_URL: 'Wxmall/Community/getPostsOperation', // creater: gaoenhui --账号概览-帖子赞藏评数据
  getPostsInteraction_URL: 'Wxmall/Community/getPostsInteraction', // creater: gaoenhui --账号概览-总互动数
  getFanBaseData_URL: 'Wxmall/Community/getFanBaseData', // creater: gaoenhui --粉丝数据基础数据
  getFansOtherData_URL: () => {
    // creater: gaoenhui --粉丝数据
    return require('@/assets/common/js/config').datacenterpath + 'Wxmall/Community/getFansOtherData'
  },
  getShoppingCart_URL: 'Wxmall/ShoppingCart/getShoppingCart', // creater: gaoenhui --购物车列表
  getRecommendByShoppingCart_URL: 'Wxmall/Item/getRecommendByShoppingCart', // creater: gaoenhui --购物车推荐商品
  checkOrder_URL: 'Wxmall/Order/checkOrder', // creater: gaoenhui --下单商品校验
  checkBuygiftNum_URL: 'Wxmall/Order/checkbuygiftnum', // 买赠赠品数量校验（选赠品页确定前校验）
  delShoppingCart_URL: 'Wxmall/ShoppingCart/delShoppingCart', // creater: gaoenhui --购物车商品删除
  addCollection_URL: 'Wxmall/Collection/addCollection', // creater: gaoenhui --添加收藏
  updateShoppingCart_URL: 'Wxmall/ShoppingCart/updateShoppingCart', // creater: gaoenhui --购物车商品修改
  getReCommendItemList_URL: 'Wxmall/User/getReCommendItemList', // creater: gaoenhui --个人中心精选好物
  getMyWapRedenv_URL: 'Wxmall/Applets/getMyWapRedenv', // creater: gaoenhui --商城端获取外链码红包封面链接
  webcheckUserinfo_URL: 'Wxmall/StoreChange/webcheckUserinfo', // creater: gaoenhui --判断店铺转让入口状态
  getGroupActivityItem_URL: 'Wxmall/Adactinfo/getGroupActivityItem', // creater: gaoenhui --热销活动列表、热门活动列表
  getGroupItemList_URL: 'Wxmall/Adactinfo/getGroupItemList', // creater: gaoenhui --获取指定分组商品信息
  getLimitActIndex_URL: 'Wxmall/LimitAct/getLimitActIndex', // creater: gaoenhui --限时秒杀活动基础信息
  getCkCommunityActList_URL: 'Wxmall/Activity/getCkCommunityActList', // creater: gaoenhui --社群推广活动
  addShoppingCart_URL: 'Wxmall/ShoppingCart/addShoppingCart',
  addItemCart_URL: 'Wxmall/Adactlinkcart/addItemCart', // creater: gaoenhui --添加分组商品-购物车
  editItemCart_URL: 'Wxmall/Adactlinkcart/editItemCart', // creater: gaoenhui --编辑分组商品-购物车
  getItemCart_URL: 'Wxmall/Adactlinkcart/getItemCart', // creater: gaoenhui --获取分组列表-购物车商品列表
  delItemCart_URL: 'Wxmall/Adactlinkcart/delItemCart', // creater: gaoenhui --删除分组商品-购物车
  cancelRefundOrder_URL: 'Wxmall/OrderRefund/cancelRefundOrder',
  getRefundOrderInfo_URL: 'Wxmall/OrderRefund/getRefundOrderInfo',
  addCommentByReturn_URL: 'Wxmall/Comment/addCommentByReturn',
  checkDrawOrderRefund_URL: 'Wxmall/OrderRefund/checkDrawOrderRefund',
  applyBatchRefund_URL: 'Wxmall/OrderRefund/applyBatchRefund',
  applyRefund_URL: 'Wxmall/OrderRefund/applyRefund',
  addApplyOrder_URL: 'Wxmall/OrderRefund/addApplyOrder',
  getRefundBankCardInfo_URL: 'Wxmall/OrderRefund/getRefundBankCardInfo',
  getReturnReason_URL: 'Wxmall/OrderRefund/getReturnReason',
  getRefundOrderMoney_URL: 'Wxmall/OrderRefund/getRefundOrderMoney',
  saveRefundOrderTransInfo_URL: 'Wxmall/OrderRefund/saveRefundOrderTransInfo',
  getRefundOrderTrans_URL: 'Wxmall/OrderRefund/getRefundOrderTrans',
  getRefundOrderTransInfo_URL: 'Wxmall/OrderRefund/getRefundOrderTransInfo',
  editApplyOrder_URL: 'Wxmall/OrderRefund/editApplyOrder',
  getEditApplyOrder_URL: 'Wxmall/OrderRefund/getEditApplyOrder',
  submitQuestions_URL: 'Wxmall/Comment/submitQuestions',
  getQandalist_URL: 'Wxmall/Comment/getQandalist',
  addCommentLike_URL: 'Wxmall/Comment/addCommentLike',
  getItemshowList_URL: 'Wxmall/Comment/getItemshowList',
  setAnswerlike_URL: 'Wxmall/Comment/setAnswerlike',
  submitAnswer_URL: 'Wxmall/Comment/submitAnswer',
  getAnswerist_URL: 'Wxmall/Comment/getAnswerist',
  getQuestionsinfo_URL: 'Wxmall/Comment/getQuestionsinfo',
  getItemList_URL: 'Wxmall/Item/getItemList',
  /** 频道分类页「全部」下系列 tab：需 channelid；返回 data.list[{ seriesId, seriesName }]（路径需与后端一致） */
  getMarketTypeList_URL: 'Wxmall/Market/getMarketTypeList',
  getCategoryList_URL: 'Wxmall/Item/getCategoryList',
  /** 系列栏目专区页商品列表：参数 seriesid，支持分页 pageno/pagesize */
  getSeriesZoneList_URL: 'Wxmall/Home/getSeriesZoneList',
  communityPosts_collection_URL: 'Wxmall/CommunityPosts/collection',
  communityPosts_likes_URL: 'Wxmall/CommunityPosts/likes',
  community_follow_URL: 'Wxmall/Community/follow',
  getCouponActStatus_URL: 'Wxmall/Coupon/getCouponActStatus',
  getSubscribe_URL: 'Wxmall/User/getSubscribe',
  getItemMarquee_URL: 'Wxmall/Item/getItemMarquee',
  getCertmanageList_URL: 'Wxmall/Community/getCertmanageList',
  getCreatorApplyInfo_URL: 'Wxmall/Community/getCreatorApplyInfo',
  setCreatorApplyInfo_URL: 'Wxmall/Community/setCreatorApplyInfo',
  sendPostsIntegral_URL: 'Wxmall/Community/sendPostsIntegral',
  commentReply_URL: 'Wxmall/CommunityPosts/commentReply',
  reply_URL: 'Wxmall/CommunityPosts/reply',
  comment_URL: 'Wxmall/CommunityPosts/comment',
  getReplyList_URL: 'Wxmall/CommunityPosts/getReplyList',
  getCommentList_CommunityPosts_URL: 'Wxmall/CommunityPosts/getCommentList',
  getPostsDetail_URL: 'Wxmall/CommunityPosts/getPostsDetail',
  addDraft_URL: 'Wxmall/CommunityPosts/addDraft',
  addPosts_URL: 'Wxmall/CommunityPosts/addPosts',
  getCommunityUserIscreator_URL: 'Wxmall/Community/getCommunityUserIscreator',
  cleanNews_URL: 'Wxmall/CommunityPosts/cleanNews',
  getNews_URL: 'Wxmall/Community/getNews',
  getOfficialMsg_URL: 'Wxmall/Community/getOfficialMsg',
  report_URL: 'Wxmall/CommunityPosts/report',
  searchTopic_URL: 'Wxmall/Community/searchTopic',
  getCreditscoreRecord_URL: 'Wxmall/Community/getCreditscoreRecord',
  getDraft_URL: 'Wxmall/CommunityPosts/getDraft',
  getFollow_URL: 'Wxmall/Community/getFollow',
  getPostsIntegralRecord_URL: 'Wxmall/Community/getPostsIntegralRecord',
  getAllTopic_UTL: 'Wxmall/CommunityPosts/getAllTopic',
  getItemByCounpon_URL: 'Wxmall/item/getItemByCounpon',
  saveMeetinginfo_URL: 'Wxmall/VipGift/saveMeetinginfo',
  initAddress_URL: 'Wxmall/Address/initAddress',
  getMeetInfo_URL: 'Wxmall/VipGift/getMeetInfo',
  getMeetList_URL: 'Wxmall/VipGift/getMeetList',
  mobileLogin_URL: 'Wxmall/VipGift/mobileLogin',
  smsCodeVerify_URL: 'Wxmall/Sms/smsCodeVerify',
  getValidCode_URL: 'Wxmall/Sms/getValidCode',
  getMeetOrderList_URL: 'Wxmall/VipGift/getMeetOrderList',
  addCkysPrizes_URL: 'Wxmall/Prizes/addCkysPrizes',
  doCkysPrizes_URL: 'Wxmall/Prizes/doCkysPrizes',
  getCkysPrizesInfo_URL: 'Wxmall/Prizes/getCkysPrizesInfo',
  getExclusiveList_URL: 'Wxmall/User/getExclusiveList',
  checkJzGiftAct_URL: 'Wxmall/DrainageAct/checkJzGiftAct',
  getJzGiftActIndex_URL: 'Wxmall/DrainageAct/getJzGiftActIndex',
  getSalseRankList_URL: 'Wxmall/Adactinfo/getSalseRankList',
  getNewGroupActivityItem_URL: 'Wxmall/Adactinfo/getNewGroupActivityItem',
  verifyGroupPassword_URL: 'Wxmall/Adactinfo/verifyGroupPassword', // 分组商品地区口令-校验地区和口令
  getNewItemList_URL: 'Wxmall/Adactinfo/getNewItemList',
  getHotItemList_URL: 'Wxmall/Adactinfo/getHotItemList',
  getRecommendItemList_URL: 'Wxmall/Search/getRecommendItemList',
  getLoveItemInfo_URL: 'Wxmall/Adactinfo/getLoveItemInfo',
  getHotItem_URL: 'Wxmall/Search/getHotItem',
  getSearchList_URL: 'Wxmall/Search/getSearchList',
  addHotActivityRecord_URL: 'Wxmall/Goldmall/addHotActivityRecord',
  addLiveDetail_URL: 'Wxmall/Applets/addLiveDetail',
  getQrcode_URL: 'Wxmall/Qwqrcode/getQrcode',
  getActList_URL: 'Wxmall/Adactinfo/getActList',
  weixin_wxpay2_URL: 'pay/wxmall_pay/weixin/example/wxpay2.php',
  weixinnet_wxpay2_URL: 'pay/wxmall_pay/weixinnet/example/wxpay2.php',
  swiftpass_pay_URL: 'pay/swiftpass_pay/app.php',
  check_order_status_URL: 'Wxmall/Sysinfo/check_order_status',
  getPayInfo_URL: 'Wxmall/Sysinfo/getPayInfo',
  addZtOrder_URL: 'Wxmall/Emplgroup/addZtOrder',
  consumeItemIntegral_URL: 'Wxmall/Course/consumeItemIntegral',
  exchangeItem_URL: 'Wxmall/Integralmall/exchangeItem',
  addOrderByPrize_URL: 'Wxmall/NewItem/addOrderByPrize',
  getAddressById_URL: 'Wxmall/Address/getAddressById',
  getDefaultAddress_URL: 'Wxmall/Address/getDefaultAddress',
  getConfirmItems_Integralmall_URL: 'Wxmall/Integralmall/getConfirmItems',
  calculateFreight_URL: 'Wxmall/Address/calculateFreight',
  calculateActFreight_URL: 'Wxmall/Address/calculateActFreight',
  exchangeCoupon_URL: 'Wxmall/Integralmall/exchangeCoupon',
  getIntegralDiscountItemList_URL: 'Wxmall/Integralmall/getIntegralDiscountItemList',
  getIndex_Goldmall_URL: 'Wxmall/Goldmall/getIndex',
  signIn_URL: 'Wxmall/Integralmall/signIn',
  userSign_URL: 'Wxmall/Integralmall/userSign',
  getSignRecord_URL: 'Wxmall/Integralmall/getSignRecord',
  getIntegral_URL: 'Wxmall/Integral/getIntegral',
  getCommentByItem_URL: 'Wxmall/Comment/getCommentByItem',
  getItegralItemDetail_URL: 'Wxmall/Integralmall/getItegralItemDetail',
  getRecommendByItemInfo_URL: 'Wxmall/Item/getRecommendByItemInfo',
  getUserDetailList_URL: 'Wxmall/Integralmall/getUserDetailList',
  getWechatDetailList_URL: 'Wxmall/Integralmall/getWechatDetailList',
  getBindMobileTaskIntegral_URL: 'Wxmall/Integralmall/getBindMobileTaskIntegral',
  addLiveIntegral_URL: 'Wxmall/Integralmall/addLiveIntegral',
  addSkintestGold_URL: 'Wxmall/Goldmall/addSkintestGold',
  addItemGold_URL: 'Wxmall/Goldmall/addItemGold',
  addBrowseGold_URL: 'Wxmall/Goldmall/addBrowseGold',
  addHotActivityGold_URL: 'Wxmall/Goldmall/addHotActivityGold',
  getGoldTask_URL: 'Wxmall/Goldmall/getGoldTask',
  bindaxaminresult_URL: 'Wxmall/Ndo/bindaxaminresult',
  login_URL: 'Wxmall/OfflineActivity/login',
  wapLogin_URL: 'Wxmall/Waplogin/wapLogin',
  loginAdactlinkcart_URL: 'Wxmall/Adactlinkcart/login', // creater: gaoenhui --活动电话登录授权
  check_URL: 'Wxmall/OfflineActivity/check',
  updateReadStatus_URL: 'Msg/Mallmsg/updateReadStatus',
  getLogisticsMessageList_URL: 'Msg/Mallmsg/getLogisticsMessageList',
  getMessageList_URL: 'Msg/Mallmsg/getMessageList',
  getNoticeMessageList_URL: 'Msg/Mallmsg/getNoticeMessageList',
  getPersonMessageList_URL: 'Msg/Mallmsg/getPersonMessageList',
  addexamin_URL: 'Wxmall/Ndo/addexamin',
  getexaminlist_URL: 'Wxmall/Ndo/getexaminlist',
  getscheme_URL: 'Wxmall/Ndo/getscheme',
  applyLikes_URL: 'Wxmall/NewItem/applyLikes',
  getApply_URL: 'Wxmall/NewItem/getApply',
  getUserApply_URL: 'Wxmall/NewItem/getUserApply',
  addApply_URL: 'Wxmall/NewItem/addApply',
  getFeedbackList_URL: 'Wxmall/NewItem/getFeedbackList',
  getActivitylist_URL: 'Wxmall/NewItem/getActivitylist',
  getIndex_NewItem_URL: 'Wxmall/NewItem/getIndex',
  addSubscribe_URL: 'Wxmall/NewItem/addSubscribe',
  getDetail_URL: 'Wxmall/NewItem/getDetail',
  addShare_URL: 'Wxmall/NewItem/addShare',
  addBrowse_URL: 'Wxmall/NewItem/addBrowse',
  getShare_URL: 'Wxmall/NewItem/getShare',
  getShareTop_URL: 'Wxmall/NewItem/getShareTop',
  addApplyNoReason_URL: 'Wxmall/NewItem/addApplyNoReason', // creater: gaoenhui --提交申请试用
  finishApply_URL: 'Wxmall/NewItem/finishApply', // creater: gaoenhui --提交补充信息
  getLogistics_URL: 'Wxmall/Ordermanage/getLogistics',
  confirmOrderItem_URL: 'Wxmall/Ordermanage/confirmOrderItem',
  cancelOrder_URL: 'Wxmall/Ordermanage/cancelOrder',
  deleteOrder_URL: 'Wxmall/Ordermanage/deleteOrder',
  showMyCkQrcode_URL: 'Wxmall/User/showMyCkQrcode',
  getRecommendByOrderList_URL: 'Wxmall/Item/getRecommendByOrderList',
  getOrderList_URL: 'Wxmall/Ordermanage/getOrderList',
  getRefundOrderList_URL: 'Wxmall/OrderRefund/getRefundOrderList',
  checkOrderRefund_URL: 'Wxmall/OrderRefund/checkOrderRefund',
  getRefundActivityPrizeTip_URL: 'Wxmall/OrderRefund/getRefundActivityPrizeTip',
  largeCouponOrderApplyRefund_URL: 'Wxmall/OrderRefund/largeCouponOrderApplyRefund', // creater: gaoenhui --大额券订单发起售后的校验接口
  getOrderById_URL: 'Wxmall/Ordermanage/getOrderById',
  getRecommendByOrderSearch_URL: 'Wxmall/Item/getRecommendByOrderSearch',
  searchOrderList_URL: 'Wxmall/Ordermanage/searchOrderList',
  cancelSupplementFreight_URL: 'Wxmall/Order/cancelSupplementFreight',
  getPresaleJump_URL: 'Wxmall/order/getPresaleJump',
  getRecommendByPaymentPage_URL: 'Wxmall/Item/getRecommendByPaymentPage',
  checkOrderMoney_URL: 'Wxmall/GroupBuy/checkOrderMoney',
  addCommentByOrder_URL: 'Wxmall/Comment/addCommentByOrder',
  getSupplementOrderList_URL: 'Wxmall/Ordermanage/getSupplementOrderList',
  getParentOrderById_URL: 'Wxmall/Ordermanage/getParentOrderById',
  getOrderPackageInfo_URL: 'Wxmall/Ordermanage/getOrderPackageInfo',
  updateMeMobile_URL: 'Wxmall/User/updateMeMobile',
  getPrizesShareDetail_URL: 'Wxmall/Prizes/getPrizesShareDetail',
  deletePrizes_URL: 'Wxmall/Prizes/deletePrizes',
  getReceivedPrizesList_URL: 'Wxmall/Prizes/getReceivedPrizesList',
  getUnreceivedPrizesList_URL: 'Wxmall/Prizes/getUnreceivedPrizesList',
  addLeave_URL: 'Wxmall/Comment/addLeave',
  getReportList_URL: 'Wxmall/Comment/getReportList',
  addCommentLeave_URL: 'Wxmall/Comment/addCommentLeave',
  getLeaveList_URL: 'Wxmall/Comment/getLeaveList',
  getCommentById_URL: 'Wxmall/Comment/getCommentById',
  getCommentList_URL: 'Wxmall/Comment/getCommentList',
  getCouponActList_URL: 'Wxmall/coupon/getCouponActList',
  addOrderByCoupon_URL: 'Wxmall/Order/addOrderByCoupon',
  getJzGiftActItem_URL: 'Wxmall/DrainageAct/getJzGiftActItem',
  collarCoupons_URL: 'Wxmall/Activity/collarCoupons',
  checkOrder_limitAct_URL: 'Wxmall/limitAct/checkOrder',
  getLimitActItem_URL: 'Wxmall/limitAct/getLimitActItem',
  getSpikeActInfo_URL: 'Wxmall/Activity/getSpikeActInfo',
  addPreItemOrder_URL: 'Wxmall/Order/addPreItemOrder',
  checkWxpItem_URL: 'Wxmall/Item/checkWxpItem',
  cancelCollection_URL: 'Wxmall/Collection/cancelCollection',
  toRedirect_URL: 'Wxmall/Sysinfo/toRedirect',
  receiveCoupon_URL: 'Wxmall/Order/receiveCoupon',
  getCouponByItem_URL: 'Wxmall/item/getCouponByItem',
  getDiscountItemForCouponList_URL: 'Wxmall/Item/getDiscountItemForCouponList',
  getItemInfo_URL: 'Wxmall/Item/getItemInfo',
  getExchangeItemInfo_URL: 'Wxmall/ExchangeItem/getExchangeItemInfo',
  getLiveItemInfo_URL: 'Wxmall/Livesubsidy/getLiveItemInfo',
  getUserIdentity_URL: 'Wxmall/Applets/getUserIdentity',
  getPublicPopup_URL: 'Wxmall/Home/getPublicPopup',
  checkStock_URL: 'Wxmall/item/checkStock',
  getExchangeAllList_URL: 'Wxmall/ExchangeItem/getExchangeAllList',
  getAllExchangeItemList_URL: 'Wxmall/Order/getAllExchangeItemList',
  getExchangeItemList_URL: 'Wxmall/ExchangeItem/getExchangeItemList',
  checkAddress_URL: 'Wxmall/Address/checkAddress',
  addOrder_InformalemplMeeting_URL: 'Wxmall/InformalemplMeeting/addOrder',
  addDrainageActivityOrder_URL: 'Wxmall/DrainageActivitySet/addDrainageActivityOrder',
  addLimitActOrder_URL: 'Wxmall/limitAct/addLimitActOrder',
  addJzGiftActOrder_URL: 'Wxmall/DrainageAct/addJzGiftActOrder',
  addNewUserOrder_URL: 'Wxmall/NewUser/addNewUserOrder',
  addOrderByWxp_URL: 'Wxmall/Order/addOrderByWxp',
  addOrder_OfflineActivity_URL: 'Wxmall/OfflineActivity/addOrder',
  addActOrder_URL: 'Wxmall/DrainageAct/addActOrder',
  addOrder_URL: 'Wxmall/Order/addOrder',
  addOrderBySpike_URL: 'Wxmall/Order/addOrderBySpike',
  addLiveOrder_URL: 'Wxmall/Livesubsidy/addLiveOrder',
  addOrder_YearActivity_URL: 'Wxmall/YearActivity/addOrder',
  addOrderBySpecail_URL: 'Wxmall/YearActivity/addOrderBySpecail',
  addChoiceItemOrder_URL: 'Wxmall/DrainageAct/addChoiceItemOrder',
  addOrderByPrizes_URL: 'Wxmall/Order/addOrderByPrizes',
  getConfirmItems_URL: 'Wxmall/Order/getConfirmItems',
  updateOrderAddress_URL: 'Wxmall/Ordermanage/updateOrderAddress',
  // creater: gaoenhui --退运费
  confirmRefundFreight_URL: () => {
    return require('@/assets/common/js/config').datacenterpath + 'Wxmall/Order/confirmRefundFreight'
  },
  // creater: gaoenhui --补运费
  confirmSupplementFreight_URL: () => {
    return (
      require('@/assets/common/js/config').datacenterpath + 'Wxmall/Order/confirmSupplementFreight'
    )
  },
  getAddressList_URL: 'Wxmall/Address/getAddressList',
  addRealname_URL: 'Wxmall/Order/addRealname',
  getCartinfo_URL: 'Wxmall/Fastcart/getCartinfo',
  saveResult_URL: 'Wxmall/YiYuanApi/saveResult',
  detail_URL: 'Wxmall/YiYuanApi/detail',
  detail_YiYuanApickys_URL: 'Wxmall/YiYuanApickys/detail',
  getSkinCoupon_URL: 'Wxmall/YiYuanApi/getSkinCoupon',
  detect_URL: 'Wxmall/YiYuanApi/detect',
  detect_YiYuanApickys_URL: 'Wxmall/YiYuanApickys/detect',
  isSureLessCoins_URL: 'Wxmall/YiYuanApi/isSureLessCoins',
  checkUser_URL: 'Wxmall/YiYuanApi/checkUser',
  saveResult_YiYuanApickys_URL: 'Wxmall/YiYuanApickys/saveResult',
  record_URL: 'Wxmall/YiYuanApi/record',
  getRecommend_YiYuanApi_URL: 'Wxmall/YiYuanApi/getRecommend',
  getRecommend_YiYuanApickys_URL: 'Wxmall/YiYuanApickys/getRecommend',
  setMeinfo_URL: 'Wxmall/StoreChange/setMeinfo',
  getChangeBase_URL: 'Wxmall/StoreChange/getChangeBase',
  bankList_URL: 'Wxmall/StoreChange/bankList',
  submitRegistOrder_URL: 'Wxmall/VipGift/submitRegistOrder',
  getRegistItem_URL: 'Wxmall/VipGift/getRegistItem',
  getAboutUs_URL: 'Wxmall/Sysinfo/getAboutUs',
  addOrderByMeetingsPrizes_URL: 'Wxmall/Order/addOrderByMeetingsPrizes',
  addAddress_URL: 'Wxmall/Address/addAddress',
  getArea_URL: 'Wxmall/Address/getArea',
  checkGetMeetingsPrizes_URL: 'Wxmall/Order/checkGetMeetingsPrizes',
  deleteAddress_URL: 'Wxmall/Address/deleteAddress',
  updateAddress_URL: 'Wxmall/Address/updateAddress',
  checkNowOfflineMeetingStatus_URL: 'Wxmall/Coupon/checkNowOfflineMeetingStatus',
  deleteCoupons_URL: 'Wxmall/Coupon/deleteCoupons',
  getProdCoupons_URL: 'Wxmall/Coupon/getProdCoupons',
  getCoupons_URL: 'Wxmall/Coupon/getCoupons',
  getRecommendByCollection_URL: 'Wxmall/Item/getRecommendByCollection',
  getCollectionList_URL: 'Wxmall/Collection/getCollectionList',
  getJzOrderList_URL: 'Wxmall/Ordermanage/getJzOrderList',
  addIdea_URL: 'Wxmall/User/addIdea',
  dealIdea_URL: 'Wxmall/User/dealIdea',
  getIdeaInfo_URL: 'Wxmall/User/getIdeaInfo',
  getMyIdea_URL: 'Wxmall/User/getMyIdea',
  delUserItemTrack_URL: 'Wxmall/User/delUserItemTrack',
  getUserItemTrackRecord_URL: 'Wxmall/User/getUserItemTrackRecord',
  getShareList_URL: 'Wxmall/User/getShareList',
  updateMeInfo_URL: 'Wxmall/User/updateMeInfo',
  getShopInfo_URL: 'Wxmall/User/getShopInfo',
  getIndex_Member_URL: 'Wxmall/Member/getIndex',
  getLevelDesc_URL: 'Wxmall/Member/getLevelDesc',
  getNewUserGiftInfo_URL: 'Wxmall/Activity/getNewUserGiftInfo',
  checkContent_URL: 'Wxmall/Applets/checkContent',
  getUserBehaviorLinkId_URL: 'Wxmall/Index/getUserBehaviorLinkId',
  getUserIdentity_DrainageDraw_URL: 'Wxmall/DrainageDraw/getUserIdentity',
  subscribeTrans_URL: 'Wxmall/Index/subscribeTrans',
  subscribeItem_URL: 'Wxmall/Item/subscribeItem',
  addTrusteeshipUserRecord_URL: 'Wxmall/Trusteeship/addTrusteeshipUserRecord',
  getUserFromOpenid_URL: 'Wxmall/User/getUserFromOpenid',
  saveExclusive_URL: 'Wxmall/User/saveExclusive',
  share_URL: 'Wxmall/WeChat/share',
  getwxSignPhoto_URL: 'Wxmall/WeChat/getwxSignPhoto',
  getCurrencyShare_URL: 'Wxmall/Share/getCurrencyShare',
  addUserLinkRecord_URL: 'Wxmall/Applets/addUserLinkRecord',
  index_URL: 'Wxmall/WeChat/index',
  getNameByKey_URL: 'Wxmall/Search/getNameByKey',
  // 2024-03-26 函金靓 gaoenhui Start
  getMainPageInfo_URL: 'Wxmall/BeautyTheory/getMainPageInfo', //主页基本信息
  getVideoClassify_URL: 'Wxmall/BeautyTheory/getVideoClassify', //一级分类
  getVideoPostList_URL: 'Wxmall/BeautyTheory/getVideoPostList', //视频帖子列表
  getVideoPostById_URL: 'Wxmall/BeautyTheory/getVideoPostById', //视频帖子详情
  getVideoDetailPostList: 'Wxmall/BeautyTheory/getVideoDetailPostList', //视频帖子详情
  searchVideo_URL: 'Wxmall/BeautyTheory/searchVideo', //帖子搜索结果
  getCommentList_BeautyTheory_URL: 'Wxmall/BeautyTheory/getCommentList', //评论列表
  addVideoComment_URL: 'Wxmall/BeautyTheory/addVideoComment', //视频帖子进行评论
  addCommentReply_URL: 'Wxmall/BeautyTheory/addCommentReply', //视频帖子的评论进行回复
  addReply_URL: 'Wxmall/BeautyTheory/addReply', //视频帖子评论的回复进行回复
  collectVideo_URL: 'Wxmall/BeautyTheory/collectVideo', //帖子收藏
  praiseVideo_URL: 'Wxmall/BeautyTheory/praiseVideo', //点赞/取消点赞
  addPlayCount_URL: 'Wxmall/BeautyTheory/addPlayCount', //帖子埋点
  follow_URL: 'Wxmall/BeautyTheory/follow', //关注/取关
  getGoodsList_URL: 'Wxmall/BeautyTheory/getGoodsList', //帖子对应多个商品列表
  receiveCoins: 'Wxmall/BeautyTheory/receiveCoins', // 领取金币
  getReplyMoreList: 'Wxmall/BeautyTheory/getReplyList', // 领取金币
  // 2024-03-26 函金靓 gaoenhui End
  getValidateCode_URL: (params) => {
    var url = require('@/assets/common/js/config').basepath + 'Msg/Captcha/getValidateCode',
      paramsData = ''
    paramsData = aes.encryptAES(params)
    url += `?appdata=${paramsData}`
    return url
  },
  clearCookie_URL: (params) => {
    var url = require('@/assets/common/js/config').basepath + 'Wxmall/WeChat/clearCookie',
      paramsData = ''
    paramsData = aes.encryptAES(params)
    url += `?appdata=${paramsData}`
    return url
  },
  getMoney_URL: 'Wxmall/UserUpgrade/getMoney', //升级50vip基础信息,
  upgrade_URL: 'Wxmall/UserUpgrade/upgrade', //会员升级资料提交
  getWhitePkWinPops_URL: 'Wxmall/Adactinfo/getWhitePkWinPops', // 7月生活品鉴官
  addOrder_PrivateActivity_URL: 'Wxmall/PrivateActivity/addOrder', // 35专属活动拉杆箱 活动_提交订单
  addCkporder_URL: 'Wxmall/PrivateActivity/addCkporder', // 35老会员引流活动_提交订单
  getUserConsultingDirection_URL: 'Wxmall/Home/getUserConsultingDirection', // creater: gaoenhui --跳转二维码客服时机
  getMemberDayAd_URL: 'Wxmall/Member/getMemberDayAd', // 商城商品分组链接弹窗
  getNotPayOrderPopup_URL: 'Wxmall/Ordermanage/getNotPayOrderPopup', // 订单未支付弹窗
  getQuanYiPopups_URL: 'Wxmall/Activity/getQuanYiPopups', // 引流裂变活动弹窗
  addLimitOrder_URL: 'Wxmall/LimitAct/addLimitOrder', // 限时秒杀v2商品下单
  getCouponPopupSet_URL: 'Wxmall/Coupon/getCouponPopupSet', // creater: gaoenhui --券弹窗配置
  getMeInfo_Member_URL: 'Wxmall/Member/getMeInfo', // creater: gaoenhui --个人信息
  getItemNewRecommend_URL: 'Wxmall/Item/getItemNewRecommend', // creater: gaoenhui --热销好评推荐
  getYearActivityDrawResult_URL: 'Wxmall/YearActivity/getYearActivityDrawResult', // creater: gaoenhui --红包雨-抽奖
  saveUpgradeData_URL: 'Wxmall/Activity/saveUpgradeData', // creater: gaoenhui --用户升级提交资料
  getYearReportPop_URL: 'Wxmall/Index/getYearReportPop', // creater: gaoenhui --年度分析报告首页弹窗
  getOfflineYLMeeting_URL: 'Wxmall/InformalemplMeeting/getOfflineYLMeeting', // creater: gaoenhui --支付结果页-线下会议信息
  addOfflineYLMeeting_URL: 'Wxmall/InformalemplMeeting/addOfflineYLMeeting', // creater: gaoenhui --支付结果页-提交报名信息
  getUserNewPageInfo_URL: 'Wxmall/Home/getUserNewPageInfo', // creater: gaoenhui --是否新版
  getStoreZoneList_URL: 'Wxmall/Home/getStoreZoneList', // creater: gaoenhui --品牌列表
  getConfirmItemsByGroupBuy_URL: 'Wxmall/QyGroupBuy/getConfirmItemsByGroupBuy', // 企业团购-获取下单商品信息
  addQyGroupOrder_URL: 'Wxmall/QyGroupBuy/addQyGroupOrder', // 企业团购-提交订单
  /** 益司轻二期拼团（ck_group） */
  getCkGroupJoinDetail_URL: 'Wxmall/CkGroup/getJoinGroupDetail',
  checkCkGroupJoin_URL: 'Wxmall/CkGroup/checkJoin',
  checkCkGroupUserPerm_URL: 'Wxmall/CkGroup/checkUserPerm',
  loginCkGroup_URL: 'Wxmall/CkGroup/login',
  getCkGroupOrderInit_URL: 'Wxmall/CkGroup/getOrderInit',
  submitCkGroupOrder_URL: 'Wxmall/CkGroup/submitOrder'
}



// WEBPACK FOOTER //
// ./src/axiosApi/ajax_config.js